import { allFeaturesUrls } from './choose-plan-card.model';

type FeaturesUrlLocale = keyof typeof allFeaturesUrls;

const isFeaturesUrlLocale = (locale: string): locale is FeaturesUrlLocale => Object.hasOwn(allFeaturesUrls, locale);

// Only a subset of locales has its own pricing page, so an unmapped locale yields nothing.
export const getAllFeaturesUrl = (locale: string): string | undefined =>
  isFeaturesUrlLocale(locale) ? allFeaturesUrls[locale] : undefined;
